export const ROOT = '/';
export const LOGIN = 'login';
export const FORGOT_PASSWORD = 'forgot-password';
export const RESET_PASSWORD = `reset-password`;
export const CREATE_PASSWORD = `create-password`;
export const SIGNUP = 'signup';
export const OTP = 'otp';

export const HOME = '';
export const PROMOTION = 'promotion';
export const REQUEST = 'request';
export const TRIP = 'trip';
export const CUSTOMER = 'customer';
export const TRAVELER = 'traveler';
export const TEAM_MEMBER = 'team-member';
export const FEEDBACK = 'feedback';
export const REPORTS = 'reports';
export const FINANCIAL = 'financial';
export const PROFILE = 'profile';
export const BANNER_CONFIG = 'banner-configuration';
export const NOTIFICATION = 'notifications';
export const SEARCH = 'search';

export const VIEW = 'view';
export const EDIT = 'edit';
export const CREATE = 'create';

export const DOCUMENT_EXPIRATION_ALERT_UNSUBSCRIBE = 'alerts/agency/:agencyId/traveler/:travelerId/unsubscribe';
